// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportFetcher.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import fetch from 'share/fetch/Izenda.Fetch';

import exportUtils from 'share/export/Izenda.Export';
import SecurityManager from 'share/authorization/Izenda.SecurityManager';
import config from 'config';
import ExportFormat from 'logic/data/Izenda.ExportFormatConstants';
import { omit, assign } from 'lodash/fp';
const ROOT_URL = 'export/';

export default {
  export(options, successCallBack, failCallBack) {
    ensure(options.format, 'Format must be defined');
    ensure(
      options.reportId || options.dashboardId || options.reportDefinition,
      'Ether report or dashboard ID must be set'
    );

    const exportUrl = ROOT_URL + options.format;
    const exportData = omit('format', options);

    exportData.fileSessionKey = exportData.reportId || exportData.dashboardId;

    if (!!config.Integration) {
      exportData.token = new SecurityManager().getAccessToken();
    }

    const exportUtil = exportUtils(exportUrl);

    return options.format !== ExportFormat.HTML.value
      ? exportUtil.post(exportData, successCallBack, failCallBack, this.checkExportStatus)
      : fetch(`${ROOT_URL}html`).post(exportData);
  },

  /**
   * Send Email
   * @param {object} objectID
   * @param {object }email
   * @returns {Promise}
   */
  email(objectID, email) {
    const data = assign(objectID, {
      deliveryType: 'Email',
      deliveryMethod: email.deliveryMethod,
      exportAttachmentType: email.attachmentType,
      emailSubject: email.subject,
      emailBody: email.body,
      recipients: email.to,
      additionalRecipients: email.cc
    });
    return fetch(`${ROOT_URL}email`).post(data);
  },

  /**
   * export performanceStatisticsTrend
   */
  exportPerformanceStatisticsTrend() {
    const exportUrl = `${ROOT_URL}performanceStatisticsTrend`;
    const exportData = { fileSessionKey: 'Performance Statistics Trend' };
    return exportUtils(exportUrl).post(exportData);
  },

  /**
   * check status of export file
   */
  checkExportStatus(fileSession) {
    const checkStatusUrl = `${ROOT_URL}checkExportStatus/${fileSession}`;
    return fetch(checkStatusUrl).get();
  }
};



// WEBPACK FOOTER //
// ./ui/fetchers/Izenda.ExportFetcher.js